import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import ProfileTitle from '../../../../layout/mobile/profile/ProfileTitle';
import ExchangeDesktop from './desktop/ExchangeDesktop';
import ExchangeMobile from './mobile/ExchangeMobile';
import {
  getCustomerExchange,
  getBalanceForGCFromClient,
} from '../../../../../redux/actions/BankActions';
import EmptyState from './emptyState/EmptyState';

import TrackingLoading from '../../../mis-compras/components/tracking/trackingLoading.gif';
import ExchangeIcon from '../../../../common/icons/ExchangeIcon';
import { useContainerStyles } from '../points/styles';

const Exchange = ({ ...props }) => {
  const { mobile, categories } = props;
  const classes = useContainerStyles();
  const dispatch = useDispatch();

  const { exchanges, exchangesStatus, balance } = useSelector(
    (state) => state.bankReducer,
  );

  useEffect(() => {
    if (exchanges.length > 0) {
      exchanges.forEach((exchange) => {
        if (exchange.category === 'gift-card') {
          dispatch(getBalanceForGCFromClient(exchange.productFolio));
        }
      });
    }
  }, [exchanges]);

  useEffect(() => {
    if (exchangesStatus === 'idle') dispatch(getCustomerExchange());
  }, []);

  return (
    <React.Fragment>
      <ProfileTitle
        title={<strong>Mis canjes realizados</strong>}
        subtitle="Aquí podrás ver todos los canjes que has realizado con tus Ripley Puntos Go."
        mobile={mobile}
        icon={<ExchangeIcon size="30px" color="#6A148E" />}
      />
      {exchangesStatus === 'loading' && (
        <div className={classes.loadingContainer}>
          <img className={classes.loadingImage} src={TrackingLoading} />
        </div>
      )}
      {exchanges.length === 0 && exchangesStatus === 'succeded' && (
        <EmptyState />
      )}
      {!mobile && exchanges.length > 0 && (
        <ExchangeDesktop
          rows={exchanges}
          instructions={categories}
          balance={balance}
        />
      )}
      {mobile && exchanges.length > 0 && (
        <ExchangeMobile
          mobile={mobile}
          rows={exchanges}
          instructions={categories}
          balance={balance}
        />
      )}
    </React.Fragment>
  );
};

Exchange.propTypes = {
  categories: PropTypes.array,
  mobile: PropTypes.bool,
};

export default Exchange;
